export default __webpack_public_path__ + "static/media/ic_dialog_edit.ca41e857.svg";